import React from 'react';
import {
  Paper,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  Button
} from '@mui/material';
import {
  Person as PersonIcon,
  Money as MoneyIcon,
  Check as CheckIcon
} from '@mui/icons-material';
import { formatCurrency, formatDate } from '../../utils/liquidacionHelpers';

/**
 * Componente de tabla de trabajadores con servicios pendientes
 * @param {Array} trabajadoresPendientes - Lista de trabajadores
 * @param {Function} onLiquidar - Callback al hacer clic en liquidar
 */
const TablaTrabajadoresPendientes = ({ trabajadoresPendientes = [], onLiquidar }) => {
  return (
    <Paper sx={{ mb: 4, borderRadius: 3, border: '1px solid #E2E8F0' }}>
      {/* Header */}
      <Box sx={{ p: 3, borderBottom: '1px solid #E2E8F0' }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1A237E', display: 'flex', alignItems: 'center', gap: 1 }}>
          <PersonIcon sx={{ color: '#4CAF50' }} />
          Trabajadores con Servicios Pendientes
          <Chip label={trabajadoresPendientes.length} size="small" color="success" sx={{ ml: 1 }} />
        </Typography>
      </Box>

      <TableContainer>
        <Table>
          <TableHead sx={{ bgcolor: 'rgba(76, 175, 80, 0.1)' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Trabajador</TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                Servicios
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                Comisiones
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                Egresos
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                Balance Neto
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                Período
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {trabajadoresPendientes.map((trabajador) => (
              <TableRow
                key={trabajador.id_trabajador}
                sx={{
                  '&:hover': { bgcolor: 'rgba(76, 175, 80, 0.04)' },
                  borderLeft:
                    trabajador.balance_neto < 0
                      ? '4px solid #f44336'
                      : '4px solid #4caf50'
                }}
              >
                <TableCell>
                  <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                      {trabajador.nombre_trabajador} {trabajador.apellido_trabajador}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      ID: {trabajador.id_trabajador}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell align="center">
                  <Chip label={trabajador.servicios_pendientes} color="primary" size="small" />
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#4CAF50' }}>
                    {formatCurrency(trabajador.total_comisiones)}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 'bold',
                      color: trabajador.egresos_pendientes > 0 ? '#FF5722' : '#757575'
                    }}
                  >
                    {formatCurrency(trabajador.egresos_pendientes)}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 'bold',
                      color: trabajador.balance_neto >= 0 ? '#4CAF50' : '#f44336'
                    }}
                  >
                    {formatCurrency(trabajador.balance_neto)}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" color="text.secondary">
                    {formatDate(trabajador.servicio_mas_antiguo)} -<br />
                    {formatDate(trabajador.servicio_mas_reciente)}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Button
                    variant="contained"
                    size="small"
                    startIcon={<MoneyIcon />}
                    onClick={() => onLiquidar(trabajador)}
                    sx={{
                      background: 'linear-gradient(135deg, #1A237E 0%, #3949AB 100%)',
                      borderRadius: 2
                    }}
                  >
                    Liquidar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Mensaje cuando no hay pendientes */}
      {trabajadoresPendientes.length === 0 && (
        <Box sx={{ p: 4, textAlign: 'center' }}>
          <CheckIcon sx={{ fontSize: 60, color: '#4CAF50', mb: 2 }} />
          <Typography variant="h6" color="text.secondary">
            ¡Excelente! No hay servicios pendientes de liquidar
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default TablaTrabajadoresPendientes;
